import Config from '@configs/Environments';
import useAxios from 'axios-hooks';
import useMockServer from './useMockServer';

const path = Config.API_END_POINT + '/entry/abolitions/';

const useAllListData = (params:any): any => {
    const id = params.swCloseRequestId;
    const pathEnd = '/memos' + (useMockServer ? '' : '?timestamp=' + params.timestamp);

    const result: any = useAxios(`${path}${id}${pathEnd}`, { useCache: false });
    if (useMockServer) {
        const data = result[0].data?.list;
        const loading = result[0].loading;
        const error = result[0].error;
        history.getList.list = data;
        return { data, loading, error };
    } else {
        const [{ data, loading, error }] = result;
        history.getList.list = data;
        return { data, loading, error };
    }
};

const history: any = {
    getList: {
        list: []
    },
};

const createPostData = (data: any): any => {
    if (useMockServer) {
        const postData = Object.assign({}, history.getList || {});
        return postData;
    } else {
        const postData: any = {
            swCloseRequestId: data.swCloseRequestId,
            memoContent: data.memoContent,
            createUser: data.createUser,
        };
        return postData;
    }
};

const usePostData = (params: any): any => {
    const path = Config.API_END_POINT + '/entry/abolition/memo';
    const postData = createPostData(params);
    const [{ data, loading, error }] = useAxios({
        url: path,
        method: 'POST',
        data: postData,
    });
    return { data, loading, error };
};

const useCloseRequestMemo = {
    useAllListData,
    usePostData
};

export default useCloseRequestMemo;